<template>
  <analytics-sub-page
    title="Safeguarding"
    icon="shield-check"
    css-class="analytics-safeguarding"
    default-label="Safeguarding"
    :show-divisions-dropdown="false"
    :section-specs="sectionSpecs"
  >
    <safeguarding-metrics ref="safeguardingRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import SafeguardingMetrics from '@/pages/analyticsSafeguarding/components/SafeguardingMetrics.vue';

const safeguardingRef = ref(null);

const sectionSpecs = [{ key: 'safeguarding', label: 'Safeguarding', ref: safeguardingRef }];
</script>
